import { ReactElement, useContext } from "react";
import { Button } from "@justworkshr/milo-core";

import { Factor } from "types/factor/factor";

import RemoveFactorContext from "../../../contexts/RemoveFactorContext";

const RemoveFactorButton = ({ factor }: { factor: Factor }): ReactElement => {
  const { openRemoveModal } = useContext(RemoveFactorContext);

  return (
    <Button
      color="destructive"
      variant="outlined"
      onClick={() => openRemoveModal(factor)}
    >
      Remove
    </Button>
  );
};

export default RemoveFactorButton;
